"use client";
import LocalizedLink from "@/components/LocalizedLink";
import Image from "next/image";
interface HeroBlockCustomProps {
  color?: "violet" | "green" | "blue";
}

export default function HeroBlockCustomConfernce({
  color = "green",
}: HeroBlockCustomProps) {
  const backgroundColorClass =
    {
      green: "custom-gradient-green-btn",
      blue: "custom-gradient-blue-btn",
      violet: "custom-gradient-violet-btn",
    }[color] || "custom-gradient-green-btn";
  return (
    <>
      <div
        data-meta="HeroBlockCustomConference"
        className="relative container mx-auto px-4 sm:px-6 lg:px-8  mb-8 sm:mb-14"
      >
        <div className="sm:px-6 lg:mt-12 lg:px-8">
          <div className="relative">
            <div className="flex lg:hidden text-center relative  flex-col justify-end py-6">
              <div className="pb-4 border-b border-white/50">
                <p
                  className={`text-3xl sm:text-4xl lg:text-6xl font-bold uppercase text-transparent`}
                >
                  <span className="text-white">події</span>{" "}
                  <span className={`custom-gradient-green-text`}>
                    AP Education
                  </span>
                </p>
                <p className="text-white text-md">онлайн і офлайн</p>
              </div>
            </div>
            <Image
              width={1536}
              height={700}
              src="/assets/photoAP/eventHeroSM.webp"
                alt=""
              className="object-cover w-full h-full block lg:hidden"
            />
            <Image
              width={1536}
              height={700}
              src="/assets/photoAP/eventHero.webp"
                alt=""
              className="!hidden lg:!block object-cover w-full h-full mask-second large"
            />
            <div className="hidden lg:flex absolute right-0 left-0 bottom-[15%]  flex-col justify-between p-8">
              <div>
                <h1
                  className={`text-xl md:text-3xl lg:text-6xl font-bold uppercase text-transparent mt-2`}
                >
                  <span className="text-white">події</span>
                  <br />
                  <span className={`custom-gradient-green-text`}>
                    AP Education
                  </span>
                </h1>
                <p className="mt-2 text-white text-md">онлайн і офлайн</p>
              </div>
            </div>
            <div className=" hidden lg:block absolute top-[90%] right-0">
              <div className="flex md:gap-2 xl:gap-12 items-center">
                <p className="text-white text-xs md:text-sm xl:text-base">
                  Цікавить подія?
                </p>
                <LocalizedLink
                  href={`/event-form`}
                  className={`uppercase ${backgroundColorClass} rounded-full px-8 py-2.5 text-center text-sm font-fixel font-bold text-white shadow-sm focus-visible:outline`}
                >
                  зареєструватися
                </LocalizedLink>
              </div>
            </div>
          </div>
        </div>
        <div className="lg:hidden mt-4 font-fixel py-4 text-white text-md rounded-3xl flex flex-col justify-center items-center gap-4">
          Цікавить подія?
          <LocalizedLink
            href={`/conference-form`}
            className={`${backgroundColorClass} uppercase text-white rounded-full px-8 py-2.5 text-center text-sm font-fixel font-bold focus-visible:outline`}
          >
            зареєструватися
          </LocalizedLink>
        </div>
      </div>
    </>
  );
}
